import { render, staticRenderFns } from "./ItemEladott.vue?vue&type=template&id=4dd1e56b&scoped=true&"
import script from "./ItemEladott.vue?vue&type=script&lang=js&"
export * from "./ItemEladott.vue?vue&type=script&lang=js&"
import style0 from "./ItemEladott.vue?vue&type=style&index=0&id=4dd1e56b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd1e56b",
  null
  
)

export default component.exports